import { DIRECCIONES_PROVINCIALES } from '../../data/direccionesProvinciales';
import Container from '../../components/shared/Container';
import PageHero from '../../components/shared/PageHero';
import styles from './DireccionesProvincialesPage.module.css';

const toTelHref = (phone: string): string => `tel:${phone.replace(/\s+/g, '')}`;

const DIRECCIONES_ORDENADAS = [
  ...DIRECCIONES_PROVINCIALES.filter((direccion) => direccion.province !== 'Albacete'),
  ...DIRECCIONES_PROVINCIALES.filter((direccion) => direccion.province === 'Albacete'),
];

export default function DireccionesProvincialesPage() {
  return (
    <>
      <PageHero
        breadcrumb={[{ label: 'Inicio', to: '/' }, { label: 'Direcciones provinciales' }]}
        title="Direcciones provinciales"
        subtitle="Consulta las sedes y centros asistenciales de Solimat por provincia."
      />

      <Container as="section" className={styles.section}>
        <p className={styles.intro}>
          Encuentra la direccion, telefono y correo de cada delegacion provincial para contactar con el equipo
          adecuado de forma directa.
        </p>

        <div className={styles.grid}>
          {DIRECCIONES_ORDENADAS.map((direccion) => (
            <article
              key={direccion.province}
              className={
                direccion.items.length > 2
                  ? `${styles.provinceCard} ${styles.provinceCardFeatured}`
                  : styles.provinceCard
              }
            >
              <header className={styles.provinceHeader}>
                <div>
                  <span className={styles.provinceEyebrow}>Provincia</span>
                  <h2 className={styles.provinceTitle}>{direccion.province}</h2>
                </div>
                <span className={styles.officeCount}>
                  {direccion.items.length} {direccion.items.length === 1 ? 'centro' : 'centros'}
                </span>
              </header>

              <div className={styles.offices}>
                {direccion.items.map((item) => (
                  <section key={`${direccion.province}-${item.name}`} className={styles.officeCard}>
                    <div className={styles.officeHeading}>
                      <span className={styles.officeIcon} aria-hidden="true">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                          <path d="M4 21h16M6 21V7l6-4 6 4v14M9 10h1M14 10h1M9 14h1M14 14h1M10 21v-3h4v3" />
                        </svg>
                      </span>
                      <h3 className={styles.officeTitle}>{item.name}</h3>
                    </div>

                    <div className={styles.officeDetails}>
                      <p className={styles.address}>
                        <svg aria-hidden="true" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                          <path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z" />
                          <circle cx="12" cy="10" r="2.5" />
                        </svg>
                        <span>{item.address}</span>
                      </p>
                      <div className={styles.contactList}>
                        <a className={styles.link} href={toTelHref(item.phone)}>
                          <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                            <path d="M6.6 3h3l1.5 4-2 1.5a15 15 0 0 0 6.4 6.4l1.5-2 4 1.5v3c0 1.7-1.3 3-3 3A15 15 0 0 1 3.6 6c0-1.7 1.3-3 3-3Z" />
                          </svg>
                          <span>{item.phone}</span>
                        </a>
                        {item.email ? (
                          <a className={styles.link} href={`mailto:${item.email}`}>
                            <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                              <path d="M4 4h16v16H4zM4 6l8 7 8-7" />
                            </svg>
                            <span>{item.email}</span>
                          </a>
                        ) : null}
                      </div>
                    </div>
                  </section>
                ))}
              </div>
            </article>
          ))}
        </div>
      </Container>
    </>
  );
}
